import { format, parseISO, isValid } from 'date-fns';
import { IValidatingCarrier } from 'features/transactions/types';

/** Formato ISO local que espera el API para `limitDate` del servicio vuelo. */
export const formatFlightLimitDateForApi = (value: string): string => {
	const trimmed = value.trim();
	if (!trimmed) {
		return '';
	}
	if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(trimmed)) {
		return trimmed;
	}
	if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(trimmed)) {
		return `${trimmed}:00`;
	}
	if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
		return `${trimmed}T12:00:00`;
	}
	const parsed = parseISO(trimmed);
	return isValid(parsed) ? format(parsed, 'yyyy-MM-dd\'T\'HH:mm:ss') : trimmed;
};

export const suggestFlightLimitDateTimeLocal = (): string => {
	return format(new Date(), 'yyyy-MM-dd\'T\'23:59');
};

export const buildValidatingCarrierForApi = (code: string): IValidatingCarrier => ({
	code: code.trim().toUpperCase(),
	name: code.trim(),
});

export const isPnrFilled = (pnr: string): boolean => {
	const trimmed = pnr.trim();
	return trimmed.length > 0 && trimmed !== '-';
};
